import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconInfoCircle } from "@tabler/icons-react";
import SubscriptionDescriptionRenderer from "../SubscriptionDescriptionRenderer";
import type { DescriptionSectionProps } from "./types";

const DescriptionSection = ({
  prompt,
  description,
  variables,
  readOnly = false,
}: DescriptionSectionProps) => {
  // For read-only legacy alerts, show description instead of prompt
  const showDescription = readOnly && !prompt && description;

  return (
    <div className="al-border al-rounded-lg al-p-6 al-bg-white">
      <Stack direction="row" gap="sm" align="center" className="al-mb-4">
        <IconInfoCircle size={20} className="al-text-blue-600" />
        <Typography variant="body" weight="medium" className="al-text-gray-900">
          Description
        </Typography>
      </Stack>
      {showDescription ? (
        <Typography variant="body" className="al-text-gray-700">
          {description}
        </Typography>
      ) : (
        <SubscriptionDescriptionRenderer prompt={prompt} variables={variables} />
      )}
    </div>
  );
};

export default DescriptionSection;
